import { InjectionToken } from '@angular/core';
import { type ApolloLink } from '@apollo/client';

// only provided by apps that use subscriptions (see provideGraphqlSubscriptions), so others don't ship ActionCable
export const GRAPHQL_SUBSCRIPTIONS_LINK = new InjectionToken<ApolloLink>('GRAPHQL_SUBSCRIPTIONS_LINK');
